import React, { Fragment } from 'react'
import ActionButtons from './elements/actionButtons'
import OperationButtons from './elements/operationButtons'
import Stake from './elements/Stake'
import { SET_STAKE_CONTENT_PROPS } from './interface'

export default function SetStakeContent({
  balance,
  colors,
  audio,
  gameInfo,
  handleNotification,
  SFX,
  isZero,
  handleModal,
  inputStake,
  setnumber,
  setinputStake,
  makeMathOperation,
  handleAllIn,
  handleSetStake,
  hasTenX,
  inputLength,
}: SET_STAKE_CONTENT_PROPS) {
  const { maxBet, minBet, precision, currency } = gameInfo

  return (
    <Fragment>
      <p>{currency}</p>
      <Stake
        gameInfo={gameInfo}
        stake={inputStake}
        setnumber={setnumber}
        setInputStake={setinputStake}
        handleNotification={handleNotification}
        isZero={isZero}
        colors={colors}
        makeMathOperation={makeMathOperation}
        SFX={SFX}
        audio={audio}
        length={inputLength}
      />
      <OperationButtons
        colors={colors}
        makeMathOperation={makeMathOperation}
        audio={audio}
        maxStake={maxBet}
        minStake={minBet}
        updateStake={handleAllIn}
        balance={balance}
        toFix={precision}
        hasTenX={hasTenX}
      />
      <ActionButtons
        colors={colors}
        audio={audio}
        SFX={SFX}
        handleSetStake={handleSetStake}
        handleAbove={handleModal}
      />
    </Fragment>
  )
}
